import { Injectable } from "@angular/core";
import { GameVariantConfigService, FavouriteGamesConfigService } from "@obg/gaming.external";
import { FetchStatusSelector } from "@obg/ngrx-utils";
import { indexOf, isEmpty, isEqual } from "lodash-es";
import { Observable } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";

import { Game } from "../../game/game.model";
import { GameSelector } from "../../game/game.selector";
import { mapGames, mapGamesByPrimaryVariantId } from "../../game/game.util";
import { GamingExternalState } from "../../state";

import { FAVOURITE_GAMES_ACTION_TYPE } from "./favourite-games.action";

@Injectable({
	providedIn: "root",
})
export class FavouriteGamesSelector {
	constructor(
		private gameSelector: GameSelector,
		private gameVariantConfigService: GameVariantConfigService,
		private favouriteGamesConfigService: FavouriteGamesConfigService
	) {}

	getAll() {
		return (state: GamingExternalState): Game[] => {
			const gameIds = state.gamingExternal.favouriteGames.items;

			if (isEmpty(gameIds)) {
				return [];
			}

			if (this.gameVariantConfigService.isGPT() || this.favouriteGamesConfigService.getUseGameIdForSIBrands()) {
				return mapGames(gameIds, this.gameSelector.getAll()(state));
			}

			return mapGamesByPrimaryVariantId(gameIds, this.gameSelector.getAll()(state));
		};
	}

	getAll$() {
		return (state$: Observable<GamingExternalState>): Observable<Game[]> =>
			state$.pipe(
				distinctUntilChanged(isEqual, (state) => [
					state.gamingExternal.favouriteGames.items,
					this.gameSelector.getAll()(state),
				]),
				map(this.getAll())
			);
	}

	isFavourite(id: string) {
		return (state: GamingExternalState): boolean => indexOf(state.gamingExternal.favouriteGames.items, id) !== -1;
	}

	isBusy() {
		return (state: GamingExternalState): boolean =>
			FetchStatusSelector.isBusy(FAVOURITE_GAMES_ACTION_TYPE.getAll)(state);
	}

	getGameId(game: Game) {
		if (this.gameVariantConfigService.isGPT()) {
			return game.id;
		}

		return this.favouriteGamesConfigService.getUseGameIdForSIBrands() ? game.id : game.primaryVariantId;
	}
}
